export enum AppTheme {
    Auto = 'auto',
    Light = 'light',
    Dark = 'dark',
}

export const APP_THEME_STORAGE_KEY = 'color-scheme';
